import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { Document, FiltersBase } from "../../types"
import { EVENT_TYPES, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Document>()

export function TableDocuments({
  documents,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  documents: Document[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!documents) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [documents, count])

  return (
    <Table
      data={documents}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Titolo"
        name="title"
        sortable
        width="minmax(400px, 1fr)"
        render={(document) => (
          <Link to={`/documents/documents/${document.id}/`}>
            <LinkMagik className="text-dark">{document.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Tipi di evento"
        name="event_types"
        sortable
        width="minmax(200px, 1fr)"
        render={(document) => (
          <>{document.event_types.map((et) => EVENT_TYPES.find((e) => e.value === et)?.label ?? et).join(", ")}</>
        )}
      />

      <Table.Column
        title="Anno"
        name="year"
        sortable
        width="minmax(100px, 1fr)"
        render={(document) => <>{document.year || "-"}</>}
      />

      <Table.Column
        title="Anno evento"
        name="event_year"
        sortable
        width="minmax(100px, 1fr)"
        render={(document) => <>{document.event_year || "-"}</>}
      />

      <Table.Column
        title="Immagine"
        name="media_data"
        width="minmax(150px, 1fr)"
        render={(document) => (
          <>
            {document.media_data_list ? (
              <img
                src={document.media_data_list.thumbnail as string}
                alt={document.media_data_list.title}
                style={{ width: 100, height: "auto" }}
              />
            ) : (
              <>-</>
            )}
          </>
        )}
      />

      <Table.Column
        title="Bozza"
        name="draft"
        sortable
        width="minmax(100px, 1fr)"
        render={(document) => <>{document.draft ? "Sì" : "No"}</>}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} documenti
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
